// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"u_","cardInnerHeading":"va","toggleWrapperClass":"vb","changeProfile":"vc vb","textWrapperClass":"vd","toggleTextClass":"ve"};